import { GeneratedSkedApiClient } from "../generated-client";
import type { paths } from "../generated/sked-api-openapi-types";

type ReplaceInboxAssetOperation =
  paths["/content-inbox/inbox/{inboxId}/assets/replace"]["post"];
export type ReplaceAssetRequest = NonNullable<
  ReplaceInboxAssetOperation["requestBody"]
>["content"]["application/json"];

const generatedSkedApiClient = new GeneratedSkedApiClient<paths>();

export async function replaceAsset(
  inboxId: string,
  request: ReplaceAssetRequest
): Promise<void> {
  const result = await generatedSkedApiClient.client.POST(
    "/content-inbox/inbox/{inboxId}/assets/replace",
    {
      params: {
        path: { inboxId },
      },
      body: request,
    }
  );

  await generatedSkedApiClient.unwrap(result);
}
